var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.123,
    height: 19.011,
    viewBox: "0 0 21.123 19.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account_tree_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "account_tree_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M93.836,235.011v-3.3H89.769V220.885H87.314v3.432H80V216h7.314v3.3h6.522V216h7.287v8.317H93.836v-3.432H91.354v9.241h2.482v-3.432h7.287v8.317ZM81.584,217.584v0ZM95.42,228.278v0Zm0-10.694v0Zm0,5.149h4.119v-5.149H95.42Zm0,10.694h4.119v-5.149H95.42ZM81.584,222.733H85.73v-5.149H81.584Z",
    transform: "translate(-80 -216)",
    fill: "#1c2d57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBlack);
export default __webpack_public_path__ + "static/media/map-black.7e01c2c8512e39c0c24719488438578b.svg";
export { ForwardRef as ReactComponent };